import { styled } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';

export const iconStyles = {
  width: 50,
  height: 50,
}

export const rootActiveStyles = {
  backgroundColor: '#e9f2f6'
}

export const Root = styled(ButtonBase)(({ theme }) => ({
  width: 'min(100%, 344px)',
  height: 122,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,
  border: '1px dashed',
  borderColor: theme.palette.primary.main,
  borderRadius: '6px',
  '&:hover': {
    ...rootActiveStyles
  }
}));

export const Title = styled('div')(({ theme }) => ({
  userSelect: 'none',
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(14),
}));

export const FileInput = styled('input')({ display: 'none' });
